import * as React from 'react';

interface ClassDetails {
  name: string;
  date: string;
  time: string;
  instructor: string;
  reason?: string;
}

interface ClassCancellationEmailProps {
  name?: string;
  company?: string;
  supportEmail?: string;
  domain?: string;
  classDetails?: ClassDetails;
  accountLink?: string;
  rescheduleLink?: string;
}

export const ClassCancellationEmail: React.FC<ClassCancellationEmailProps> = ({
  name = 'João Silva',
  company = 'Trivium',
  supportEmail = 'suporte@trivium.com.br',
  domain = 'trivium.com.br',
  classDetails = {
    name: 'Introdução ao TypeScript',
    date: '15/08/2023',
    time: '19:00',
    instructor: 'Ana Souza',
    reason: 'Problemas técnicos inesperados',
  },
  accountLink = 'https://trivium.com.br/minha-conta',
  rescheduleLink = 'https://trivium.com.br/reagendar',
}) => {
  return (
    <div style={containerStyle}>
      {/* Header */}
      <div style={headerStyle}>
        <img 
          src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Logo%20Trivium%20Rebranded%20Branco%20150%20dpi-0VfiiO2tOZNdZlvY5A7z3saYZGysgq.png" 
          alt="Trivium"
          style={logoImageStyle}
        />
      </div>
      
      {/* Content */}
      <div style={contentStyle}>
        <table cellPadding="0" cellSpacing="0" border={0} width="100%" style={{ backgroundColor: '#FFEAEA' }}>
          <tr>
            <td align="center" style={{ padding: '40px 20px' }}>
              <table cellPadding="0" cellSpacing="0" border={0} width="100%" style={{ maxWidth: '400px' }}>
                {/* Círculo com ícone */}
                <tr>
                  <td align="center" style={{ paddingBottom: '30px' }}>
                    <div style={{ 
                      width: '60px', 
                      height: '60px', 
                      borderRadius: '50%', 
                      backgroundColor: '#D32F2F', 
                      display: 'inline-block',
                      textAlign: 'center',
                      lineHeight: '60px'
                    }}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle' }}>
                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="white"/>
                      </svg>
                    </div>
                  </td>
                </tr>
                
                {/* Título */}
                <tr>
                  <td align="center" style={{ paddingBottom: '15px' }}>
                    <h1 style={{ 
                      margin: '0',
                      fontSize: '28px',
                      color: '#333333',
                      fontWeight: '600'
                    }}>
                      Aula Cancelada
                    </h1>
                  </td>
                </tr>
                
                {/* Mensagem */}
                <tr>
                  <td align="center" style={{ paddingBottom: '25px' }}>
                    <p style={{ 
                      margin: '0',
                      fontSize: '16px',
                      color: '#666666'
                    }}>
                      Pedimos desculpas pelo inconveniente
                    </p>
                  </td>
                </tr>
                
                {/* Badge */}
                <tr>
                  <td align="center">
                    <div style={{ 
                      backgroundColor: '#D32F2F',
                      borderRadius: '24px',
                      color: '#FFFFFF',
                      fontWeight: '600',
                      fontSize: '15px',
                      padding: '12px 25px',
                      display: 'inline-block'
                    }}>
                      {classDetails.date} às {classDetails.time}
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
        
        <div style={contentContainerStyle}>
          <h2 style={titleStyle}>Olá, {name}!</h2>
          
          <p style={paragraphStyle}>
            Infelizmente, precisamos cancelar sua aula de <strong>{classDetails.name}</strong> que 
            estava agendada para <strong>{classDetails.date} às {classDetails.time}</strong>.
          </p>
          
          {classDetails.reason && (
            <p style={paragraphStyle}>
              <strong>Motivo do cancelamento:</strong> {classDetails.reason}
            </p>
          )}
          
          <p style={paragraphStyle}>
            Pedimos sinceras desculpas por qualquer inconveniente que isso possa causar. 
            Nossa equipe está disponível para ajudá-lo a reagendar esta aula para uma data 
            mais conveniente para você.
          </p>
        </div>
        
        <div style={actionCardStyle}>
          <h3 style={actionTitleStyle}>O que fazer agora?</h3>
          
          <div style={actionOptionsStyle}>
            <div style={actionOptionStyle}>
              <div style={actionIconContainerStyle}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm-12-7h5v5H7v-5z" fill="#1F1746"/>
                </svg>
              </div>
              <div style={actionTextStyle}>
                <strong>Reagendar</strong><br />
                Escolha uma nova data e horário para sua aula
              </div>
            </div>
            
            <div style={actionOptionStyle}>
              <div style={actionIconContainerStyle}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z" fill="#1F1746"/>
                </svg>
              </div>
              <div style={actionTextStyle}>
                <strong>Contato</strong><br />
                Entre em contato com nosso suporte para assistência
              </div>
            </div>
          </div>
        </div>
        
        <div style={ctaContainerStyle}>
          <div style={buttonContainerStyle}>
            <a href={rescheduleLink} style={buttonStyle}>
              Reagendar Aula
            </a>
          </div>
          
          <p style={ctaTextStyle}>
            Para verificar outras opções de aulas e horários disponíveis, você também pode acessar:
          </p>
          <div style={secondaryButtonContainerStyle}>
            <a href={accountLink} style={secondaryButtonStyle}>
              Acessar Minha Conta
            </a>
          </div>
        </div>
        
        <hr style={hrStyle} />
        
        <div style={footerContentStyle}>
          <p style={footerStyle}>
            Se você tiver alguma dúvida ou precisar de assistência adicional, entre em contato conosco:
          </p>
          <div style={contactChannelsStyle}>
            <p style={contactChannelStyle}>✉️ {supportEmail}&nbsp;&nbsp;📱 (11) 3181-5940</p>
          </div>
          <p style={footerStyle}>
            Agradecemos sua compreensão.<br />
            Equipe {company}
          </p>
        </div>
      </div>
      
      {/* Footer */}
      <div style={emailFooterStyle}>
        <p style={copyrightStyle}>
          © 2025 {company}. Todos os direitos reservados.
        </p>
        <div style={footerLinksStyle}>
          <a href={`https://${domain}/termos`} style={footerLinkStyle}>Termos de Uso</a>
          <span style={footerDividerStyle}>|</span>
          <a href={`https://${domain}/privacidade`} style={footerLinkStyle}>Política de Privacidade</a>
        </div>
      </div>
    </div>
  );
};

// Estilos
const brandColor = '#1F1746';
const accentColor = '#D32F2F';
const backgroundColor = '#F5F7FA';
const textColor = '#333333';
const secondaryTextColor = '#666666';

const containerStyle = {
  fontFamily: "'Satoshi', Arial, sans-serif",
  maxWidth: '600px',
  margin: '0 auto',
  backgroundColor: backgroundColor,
};

const headerStyle = {
  backgroundColor: brandColor,
  padding: '25px',
  textAlign: 'center' as const,
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
};

const logoImageStyle = {
  maxWidth: '180px',
  height: 'auto',
  display: 'block',
  margin: '0 auto',
};

const contentStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '0 0 8px 8px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
  padding: '0',
  margin: '0 0 20px 0',
  overflow: 'hidden',
};

const contentContainerStyle = {
  padding: '0 40px',
};

const titleStyle = {
  fontSize: '24px',
  fontWeight: '600',
  color: brandColor,
  marginBottom: '16px',
  padding: '24px 0 0 0',
};

const paragraphStyle = {
  fontSize: '16px',
  lineHeight: '24px',
  color: textColor,
  margin: '16px 0',
};

const actionCardStyle = {
  padding: '24px 40px',
  backgroundColor: '#F8F9FA',
  margin: '24px 40px',
  borderRadius: '8px',
};

const actionTitleStyle = {
  fontSize: '18px',
  fontWeight: '600',
  color: brandColor,
  margin: '0 0 20px 0',
};

const actionOptionsStyle = {
  display: 'flex',
  flexDirection: 'column' as const,
  gap: '16px',
};

const actionOptionStyle = {
  display: 'flex',
  alignItems: 'flex-start',
};

const actionIconContainerStyle = {
  width: '40px',
  marginRight: '16px',
};

const actionTextStyle = {
  fontSize: '15px',
  lineHeight: '22px',
  color: textColor,
};

const ctaContainerStyle = {
  padding: '24px 40px',
};

const ctaTextStyle = {
  fontSize: '16px',
  lineHeight: '24px',
  color: textColor,
  margin: '24px 0 16px 0',
  textAlign: 'center' as const,
};

const buttonContainerStyle = {
  textAlign: 'center' as const,
  margin: '24px 0',
};

const secondaryButtonContainerStyle = {
  textAlign: 'center' as const,
  margin: '12px 0 24px 0',
};

const buttonStyle = {
  backgroundColor: accentColor,
  borderRadius: '6px',
  color: '#fff',
  fontSize: '16px',
  fontWeight: '600',
  textDecoration: 'none',
  padding: '12px 24px',
  display: 'inline-block',
  transition: 'background-color 0.3s ease',
};

const secondaryButtonStyle = {
  backgroundColor: '#FFFFFF',
  borderRadius: '6px',
  border: `1px solid ${brandColor}`,
  color: brandColor,
  fontSize: '16px',
  fontWeight: '600',
  textDecoration: 'none',
  padding: '12px 24px',
  display: 'inline-block',
  transition: 'background-color 0.3s ease',
};

const hrStyle = {
  borderColor: '#E1E4E8',
  margin: '24px 40px',
};

const footerContentStyle = {
  padding: '0 40px 32px 40px',
};

const footerStyle = {
  fontSize: '14px',
  color: secondaryTextColor,
  margin: '8px 0',
};

const contactChannelsStyle = {
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'center',
  marginBottom: '20px',
  marginTop: '8px',
};

const contactChannelStyle = {
  fontSize: '15px',
  color: textColor,
  margin: '6px 0',
  fontWeight: '500',
};

const emailFooterStyle = {
  backgroundColor: backgroundColor,
  padding: '24px 40px',
  textAlign: 'center' as const,
  borderBottomLeftRadius: '8px',
  borderBottomRightRadius: '8px',
};

const copyrightStyle = {
  fontSize: '13px',
  color: secondaryTextColor,
  margin: '0 0 12px 0',
};

const footerLinksStyle = {
  margin: '8px 0',
};

const footerLinkStyle = {
  color: brandColor,
  textDecoration: 'none',
  fontSize: '13px',
  fontWeight: '500',
};

const footerDividerStyle = {
  color: secondaryTextColor,
  margin: '0 8px',
};

export default ClassCancellationEmail; 